import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DescriptionModel } from '@core/services/base.model';
import { ClientService } from '@core/services/client/client.service';
import { RoleViewModel } from '@core/services/role/role.model';
import { RoleService } from '@core/services/role/role.service';
import { process } from '@progress/kendo-data-query';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'Teranet-RoleManagement',
  templateUrl: './role-management.component.html'
})

export class RoleManagementComponent implements OnInit {

  public gridSettings: GridSettings;
  roleList: RoleViewModel[] = [];
  clientinfos: DescriptionModel[] = [];
  clientId: number = -1;
  services: any;
  message: string = "";

  constructor(public dialog: MatDialog, private spinner: NgxSpinnerService, private roleService: RoleService, private clientService: ClientService, private router: Router) { }

  ngOnInit(): void {
    this.gridSettings = this.GridDefaultSettings();
    this.BindClientInfos();
  }

  BindClientInfos() {
    this.clientService.getClientInfoDescriptions().subscribe(data => {
      this.clientinfos = data as DescriptionModel[];
    });
  }

  lookUp() {
    this.spinner.show();
    this.roleService.getRoleByClientId(this.clientId).subscribe(x => {
      this.roleList = x;
      this.gridSettings.gridData = { data: this.roleList, total: this.roleList.length };
      this.spinner.hide();
    });
  }

  add() {
    this.router.navigateByUrl('/role');
  }

  reset() {
    this.roleList = [];
    this.clientId = -1;
    this.message = "";
  }

  public state: any = {
    skip: 0,
    take: 20,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  onClientChange() {
    this.roleList = [];
    this.message = "";
  }

  GridDefaultSettings(): GridSettings {
    return {
      state: this.state,
      gridData: process(this.roleList, this.state),
      columnsConfig: [
        {
          field: 'displayName',
          filterable: true,
          hidden: false,
          title: 'Name',
          routerLink: '/role',
          width: 80,
        },
        {
          field: 'description',
          filterable: true,
          hidden: false,
          title: 'Description',
          width: 150,
        },
        {
          field: 'id',
          filterable: false,
          hidden: false,
          icon: 'trash-alt',
          includeInChooser: false,
          title: 'Delete',
          type: 'delete',
          width: 40,
        },
      ],
    };
  }

  onDelete(roleView: RoleViewModel): void {
    this.message = "";
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: { message: 'Do you want to delete the role ?' },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.roleService.delete(roleView.id).subscribe(x => {
          if (x) {
            this.lookUp();
          }
          else {
            this.message = "There are users linked to this role. Unable to delete.";
          }
        });
      }
    });
  }

}
